import cn from 'classnames';

import { EColorMap } from '../constants/colorMap';
import { IConDefaultType } from '../types';

export interface ISparkleIconProps extends IConDefaultType {}

function SparkleIcon({ color, className, size = 24, rotate = 0, flip }: ISparkleIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g transform="translate(3 1.7376)">
          <path
            d="M8.89772 0C9.32851 0 9.68924 0.299961 9.9798 0.72007C10.2757 1.14796 10.5381 1.75461 10.7634 2.49024C11.201 3.91984 11.5137 5.88859 11.6369 8.12323C13.3915 8.24546 14.9197 8.48667 16.0276 8.80876C16.602 8.97574 17.0772 9.16829 17.4141 9.38568C17.7395 9.59561 18 9.87177 18 10.2219L17.9992 10.2545C17.9836 10.5891 17.7296 10.8546 17.4146 11.0579C17.0779 11.2753 16.6029 11.4677 16.0289 11.6346C14.9217 11.9566 13.3947 12.1975 11.6412 12.3199C11.5219 14.5749 11.2102 16.5637 10.7714 18.0085C10.5457 18.7518 10.2822 19.3648 9.98504 19.7972C9.69339 20.2215 9.33098 20.5248 8.89772 20.5248C8.46406 20.5248 8.10132 20.2209 7.80948 19.7959C7.51209 19.3628 7.2485 18.7487 7.02266 18.0042C6.58357 16.5566 6.27167 14.5639 6.15304 12.305C4.45249 12.176 2.97602 11.9344 1.90646 11.6155C1.35143 11.4501 0.892064 11.26 0.566334 11.0455C0.260978 10.8444 0.0157435 10.5825 0.000697742 10.2539L0 10.2219C2.40036e-05 9.91103 0.206488 9.65875 0.473069 9.46313C0.745537 9.26319 1.12888 9.08544 1.5912 8.92854C2.5188 8.61375 3.82051 8.36466 5.34226 8.2101L5.34691 8.20963L5.35156 8.2094L8.79225 7.99508L6.2377 6.9987L6.25433 6.82008C6.43381 4.88319 6.76138 3.2106 7.18918 2.01543C7.40262 1.41916 7.64575 0.928048 7.91763 0.581452C8.18681 0.238304 8.51461 9.25551e-06 8.89772 0Z"
            fill={color || EColorMap.gray_0}
          />
        </g>
      </svg>
    </i>
  );
}

export default SparkleIcon;
